module["exports"] = [
  " փողոց",
  " պողոտա"
];
